import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3be8aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-1/1 h-1/1" }
const _hoisted_2 = { class: "main border border-gray-400" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top_title text-xl text-white" }, "忘记密码", -1))
const _hoisted_4 = { class: "form_content" }
const _hoisted_5 = { class: "login" }
const _hoisted_6 = { class: "flex justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_form, {
          model: _ctx.formState,
          ref: "formRef",
          rules: _ctx.rules,
          name: "basic",
          onFinish: _ctx.onFinish,
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { name: "phone" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.phone,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.phone) = $event)),
                  placeholder: "输入手机号",
                  maxlength: 11
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { name: "verificationCode" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.formState.verificationCode,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.verificationCode) = $event)),
                  placeholder: "输入验证码"
                }, {
                  enterButton: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      onClick: _ctx.getCode,
                      style: {"background":"none","color":"#13C2C2"},
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.isDisposed ? `${_ctx.time}s后重新获取` : "获取验证码"), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      ghost: "",
                      onClick: _ctx.cancle
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("下一步")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules", "onFinish"])
      ])
    ])
  ]))
}